import { HttpClient } from "@angular/common/http";
import { Injectable, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { TypeTiers, TypeTiersForm } from '../models';

@Injectable()
export class TypeTiersService implements OnInit {

    typeTiersUrl = environment.dns + 'api/type/tiers/';

    constructor(private http: HttpClient) { }
    ngOnInit(): void {
        console.log(environment);
    }

    getList(): Observable<TypeTiers[]> {
        return this.http.get<TypeTiers[]>(this.typeTiersUrl + 'list');
    }

    getOne(id: number): Observable<TypeTiers> {
        return this.http.get<TypeTiers>(this.typeTiersUrl + id);
    }

    add(typeTierForm: TypeTiersForm): Observable<TypeTiers> {
        return this.http.post<TypeTiers>(this.typeTiersUrl, typeTierForm);
    }

    update(typeTierForm: TypeTiersForm): Observable<TypeTiers> {
        return this.http.put<TypeTiers>(this.typeTiersUrl, typeTierForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.typeTiersUrl + id);
    }
}